import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { type ProjectId, toProjectId } from '@atlassian/jira-shared-types';
import { useQueryParamSync } from '@atlassian/jira-software-cycle-time-breakdown-report/src/controllers/query-param-sync';
import { useSelectedRange } from '@atlassian/jira-software-cycle-time-breakdown-report/src/controllers/selected-date-range';
import { useTableFilterStore } from '@atlassian/jira-software-cycle-time-breakdown-report/src/controllers/top-filter';
import { useHistoricalCycleTimeData } from '@atlassian/jira-software-cycle-time-breakdown-report/src/services/historical-cycle-time';
import { useSmartDateRangeSelect } from '@atlassian/jira-software-cycle-time-breakdown-report/src/ui/historical-cycle-time/utils';
import { IssueChart } from '@atlassian/jira-software-cycle-time-breakdown-report/src/ui/issue-chart';
import PeriodFilter from '@atlassian/jira-software-cycle-time-breakdown-report/src/ui/period-filter';

export const Activity = () => {
	useQueryParamSync();
	const [selectedDateRange, { setSelectedRange }] = useSelectedRange();
	const { data: projectData } = useProjectContext();

	const projectId: ProjectId | null = projectData ? toProjectId(`${projectData.projectId}`) : null;
	const [filters] = useTableFilterStore();
	const { data: cycleTimeData } = useHistoricalCycleTimeData(projectId, filters);
	// @ts-expect-error - TS2345 - Argument of type '(range: DateRange) => void | Promise<void>' is not assignable to parameter of type '(range: DateRange) => Action<State>'.
	useSmartDateRangeSelect(cycleTimeData, selectedDateRange, setSelectedRange);
	return (
		<Flex direction="column" xcss={ActivitiesWrapper}>
			<PeriodFilter />
			<IssueChart />
		</Flex>
	);
};

const ActivitiesWrapper = xcss({
	width: '100%',
	paddingLeft: 'space.500',
	paddingRight: 'space.500',
});
